let currentToken;

export default (store) => () => {
  let previousToken = currentToken;
  currentToken = store.getState().auth.authToken;
  if (previousToken !== currentToken) {
    if (currentToken) {
      localStorage.setItem('authToken', currentToken);
    } else {
      localStorage.removeItem('authToken');
    }
  }
}



// WEBPACK FOOTER //
// src/auth/auth-token.observer.js